<div class="homeContainer color-primary row pad-t-8 pad-r-t-3" *ngIf="translateService.currentLang && candidate$ | async as currentCandidate">
  <div class="col-lg-3 mar-b-2">
    <div class="mar-b-2" *ngIf="status" (click)="status = ''">
      <img src="assets/images/rebrand/arrow-left-icon.png">
    </div>
    <h2 class="title-m title-r-s mar-b-1"><span>{{status == '' ? ('HOME.TEST.TITLE' |translate) : (status == 'not-finalized' ? ('HOME.TESTNOTFINALIZED.TITLE' |translate) : ('HOME.TESTFINALIZED.TITLE' |translate))}}</span>.</h2>
    <span *ngIf="status === ''" class="body-l body-r-m color-secondary">{{ 'HOME.TEST.SUBTITLE' |translate }}</span>
    <span *ngIf="status === 'not-finalized'" class="body-l body-r-m color-secondary">{{ 'HOME.TESTNOTFINALIZED.SUBTITLE' |translate }}</span>
    <span *ngIf="status === 'finalized'" class="body-l body-r-m color-secondary">{{ 'HOME.TESTFINALIZED.SUBTITLE' |translate }}</span>
  </div>

  <div id="invitationList" class="col-lg-8 offset-lg-1" *ngIf="currentCandidate.invitationsLite">

    <ng-container *ngIf="!status">
      <div class="row title-s title-r-s">
        <div class="col-lg-6" (click)="status = 'not-finalized'">
          <div class="row mar-x-0 mar-b-2 pad-2 border-secondary test-status-container">
            <div class="col-6 pad-x-0">
              <span class="mar-b-2 mar-r-b-0">{{ 'HOME.TESTNOTFINALIZED.TITLE' |translate }}</span>
              <span class="title-m title-r-m color-tertiary">{{ testNotFinalized }}</span>
            </div>
            <div class="col-6 pad-x-0 text-right body-m body-r-m color-tertiary align-items-end">
              <img src="assets/images/rebrand/pencil.png" [style]="currentProject ? 'filter: brightness(0);' : ''">
              <br><span>{{ 'HOME.TESTNOTFINALIZED.SHOWTEST' |translate }}</span>
            </div>
          </div>
        </div>
        <div class="col-lg-6" (click)="status = 'finalized'">
          <div class="row mar-x-0 mar-b-2 pad-2 border-secondary test-status-container">
            <div class="col-6 pad-x-0">
              <span class="mar-b-2 mar-r-b-0">{{ 'HOME.TESTFINALIZED.TITLE' |translate }}</span>
              <span class="title-m title-r-m color-tertiary">{{ testFinalized }}</span>
            </div>
            <div class="col-6 pad-x-0 text-right body-m body-r-m color-tertiary align-items-end">
              <img src="assets/images/rebrand/mountain.png" [style]="currentProject ? 'filter: brightness(0);' : ''">
              <br><span>{{ 'HOME.TESTFINALIZED.SHOWTEST' |translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="status">
      <div *ngFor="let invitation of currentCandidate.invitationsLite">
        <div *ngFor="let test of invitation.tests" class="text-lowercase">
          <ng-container *ngIf="(status === 'not-finalized' && ['pending', 'active', 'expired'].includes(test.status)) || (status === 'finalized' && ['completed'].includes(test.status))">
            <div class="mar-b-2 pad-2 color-primary border-secondary"
              [class]="(((test.status.toLowerCase() === 'completed') && !test.notifyAdnReport && !test.notifyMindsetDigitalReport && !test.notifyCtReport) || test.status != 'expired') ? 'cursor-pointer' : '' "
              (click)="testAction(test,invitation)">
              <div class="title-xxs title-r-xxs">
                <span *ngIf="test.testModel.origin === 'evalualia'">{{ 'CANDIDATE.TESTOF' |translate }} {{ ('TESTMODELS.EVALUALIATYPES.TYPE.' + test.testModel.type) | translate }}</span>
                <span *ngIf="test.testModel.origin === 'ct'">{{ 'CANDIDATE.TESTOF' |translate }} {{ ('TESTMODELS.CT.TYPE.' + test.testModel.type) | translate }}</span>
                <div class="d-none d-lg-block float-right pill body-m body-r-m" [class]="test.status">{{ ('STATUS.'+ test.status |uppercase) |translate }}</div>
              </div>
              <div class="mar-b-2 body-s body-r-s" *ngIf="invitation.jobtype">{{ 'HOME.TEST.JOBTYPE' |translate }}: {{('JOBTYPES.' + invitation.jobtype?.randstadJobtype) |translate}}</div>
              <div class="body-s body-r-s color-secondary">
                <ng-container *ngIf="test.status.toLowerCase() === 'active' || test.status.toLowerCase() === 'pending'">
                  {{ 'CANDIDATE.EXPIRESON' | translate }} {{ test.expiresAt | date:'dd/MM/yyyy' }}
                </ng-container>
                <ng-container *ngIf="test.status.toLowerCase() === 'completed' && (test.notifyAdnReport || test.notifyMindsetDigitalReport || test.notifyCtReport)">
                  {{ 'CANDIDATE.FINALIZEDON' | translate }} {{ test.result.finishedAt | date:'dd/MM/yyyy' }}
                  <br> {{ 'HOME.TESTFINALIZED.REPORTTIME' |translate }} {{(test.result.finishedAt | customDate: 365 ) | date:'dd/MM/yyyy'}}
                </ng-container>
                <ng-container *ngIf="test.status.toLowerCase() === 'completed' && !test.notifyAdnReport && !test.notifyMindsetDigitalReport && !test.notifyCtReport">
                  {{ 'CANDIDATE.FINALIZEDON' | translate }} {{ test.result.finishedAt | date:'dd/MM/yyyy' }}
                  <br>{{ 'CANDIDATE.NOREPORT' | translate }}
                </ng-container>
                <ng-container *ngIf="test.status.toLowerCase() === 'expired'">
                  {{ 'CANDIDATE.EXPIREDON' | translate }} {{ test.expiresAt | date:'dd/MM/yyyy' }}
                  <br>{{ 'HOME.TESTFINALIZED.EXPIRED' |translate }}
                </ng-container>
              </div>
              <div class="d-inline-block d-lg-none pill body-m body-r-m mar-t-2 mar-b-1" [class]="test.status">{{ ('STATUS.'+ test.status |uppercase) |translate }}</div>
              <div class="text-right body-m body-r-m color-tertiary">
                <div *ngIf="test.status.toLowerCase() === 'pending'"> {{ 'COMMON.BEGIN' | translate }} </div>
                <div *ngIf="test.status.toLowerCase() === 'active'"> {{ 'COMMON.CONTINUE' | translate }} </div>
                <ng-container *ngIf="(test.status.toLowerCase() === 'completed') && ((test.result.finishedAt | customDate: 365)>today)">
                  <div *ngIf="(test.testModelId === 1 || test.testModelId === 2)  && test.notifyCtReport"> {{ 'CANDIDATE.SEEADNREPORT' | translate }} </div>
                  <div *ngIf="test.notifyMindsetDigitalReport"> {{ 'CANDIDATE.SEEMDREPORT' | translate }} </div>
                  <div *ngIf="test.testModelId >= 24 && test.notifyCtReport"> {{ 'CANDIDATE.SEEREPORT' | translate }} </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>

        <div *ngIf="!(currentCandidate.invitationsLite)">
          <h4>{{ 'CANDIDATES.NORESULTS' | translate }}</h4>
        </div>
      </div>
    </ng-container>
  </div>

</div>

<ct-feedback #feedbackModal></ct-feedback>
